import React, { useEffect, useState } from "react";
import { api } from "../api/client";

type UserRow = {
  id: number;
  email: string;
  role: string;
  status: string;
  created_at: string;
};

export const AdminUsersPage: React.FC = () => {
  const [users, setUsers] = useState<UserRow[]>([]);

  const load = async () => {
    const res = await api.get("/user/list");
    setUsers(res.data.items);
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div style={{ padding: "1rem" }}>
      <h1>Admin – Nutzerverwaltung</h1>
      <table>
        <thead>
          <tr>
            <th>E-Mail</th>
            <th>Rolle</th>
            <th>Status</th>
            <th>Registriert</th>
          </tr>
        </thead>
        <tbody>
          {users.map((u) => (
            <tr key={u.id}>
              <td>{u.email}</td>
              <td>{u.role}</td>
              <td>{u.status}</td>
              <td>{new Date(u.created_at).toLocaleString("de-DE")}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
